import {useQuery} from 'react-query';
import getHomepageStoreNotifModal from './getHomepageStoreNotifModal';

const useGetHomepageStoreNotifModal = () => {
  const {data, isLoading} = useQuery(
    ['get-homepage-store-notif-modal'],
    getHomepageStoreNotifModal,
    {
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: 'always',
    },
  );

  return {storeModal: data, isLoading};
};

export default useGetHomepageStoreNotifModal;
